export const BUTTON_TYPE_ENUM = [
  'primary',
  'secondary',
  'secondaryOutline',
  'text',
  'textWhite',
] as const;

export const BUTTON_ICON_ENUM = ['none', 'left', 'right', 'both'] as const;

export type ButtonType = (typeof BUTTON_TYPE_ENUM)[number];
export type ButtonIcon = (typeof BUTTON_ICON_ENUM)[number];
